import React, { useState, useEffect, Fragment } from 'react';
import services from '../services';
import { validateProperty, validate } from "../../Common"
import { companySchemaObject } from '../CompanySchema';
import { PageHeader } from '../../../Common';
import MessageModal from '../../../UI/Modal/MessageModal';
import Joi from '@hapi/joi'
import TextField from '@material-ui/core/TextField';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';

const screenCode = 'REGULAROPERATIONENTITY';

export function CompanyAddEdit(props) {

    const { data, edit } = props.location
    const [groups, setGroups] = useState()
    const [entityTypes, setEntityTypes] = useState()
    const [title, setTitle] = useState("Add Company")
    const [buttonName, setButtonName] = useState("Save")
    const [isChanged, setIsChanged] = useState(0)
    const [company, setCompany] = useState({
        groupID: '0',
        operationEntityCode: '',
        operationEntityName: '',
        enityTypeID: '0',
        operationEntityLocation: '',
        isActive: true
                    
    });
   
    const [errors, setErrors] = useState({})
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Save/ Edit success"
    });
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false
    });

    const schema = Joi.object(companySchemaObject).options({ allowUnknown: true });

    useEffect(() => {
        trackPromise(
            getPermissions()
        );
    }, []);

    useEffect(() => {
        setIsChanged(isChanged + 1);
    }, [company]);

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'ADDEDITREGULAROPERATIONENTITY');

        if(isAuthorized === undefined){
            props.history.push('/unauthorized');
        }

        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined
        });

        if (data && edit) {
            setTitle("Edit Operation Entity")
            setCompany(data)
            setButtonName("Update")
        } else {
            setTitle("Add Operation Entity");
            var token = tokenService.getUserDetailsFromToken();
            setCompany({
                ...company,
                groupID: token.groupID

            });
        }
        
        trackPromise(
            getAllGroups()
        );

        trackPromise(
            getAllEntityTypes()
        );
    }

    async function getAllGroups() {
        const result = await services.getGroups()
        setGroups(result)
    }

    async function getAllEntityTypes() {
        const result = await services.getEntityTypes()
        setEntityTypes(result)
    }


    function handleChange(e) {
        const target = e.target
        const value = (target.name === 'isActive' || target.name === 'isErpEnabled') ? target.checked : target.value

        if (target.name === "companyCode") {
            if (target.value.length === 3) return false
        }

        const error = { ...errors }
        const errorMessage = validateProperty(target, companySchemaObject)
        errorMessage ? error[target.name] = errorMessage : delete error[target.name]

        setCompany({
            ...company,
            [e.target.name]: value
        })
        setErrors(error)
    }

    async function handleSave(e) {
        e.preventDefault()

        const errorMessages = validate(schema, company)
        errorMessages !== null ? setErrors(errorMessages) : setErrors({})

        if (errorMessages) return

        if (!edit) {
            const response = await services.saveRegularOperationEntity(company)
            setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
            afterSuccessfulyChanged(response.statusCode)
        }
        if (edit) {
            const response = await services.editData(company)
           
            setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
            afterSuccessfulyChanged(response.statusCode)
        }
    }

    function afterSuccessfulyChanged(response) {
        if (response === "Success") {
            clearState()
            setTimeout(() => {
                props.history.push({ pathname: '/regularOperationEntity' })
            }, 1500);
        }
    }

    function onCancelClick() {
        clearState();
        setErrors({});
    }

    function clearState() {
        var token = tokenService.getUserDetailsFromToken();
        setCompany({
            ...company,
            groupID: permissionList.isGroupFilterEnabled ? '0' : token.groupID,
            operationEntityCode: '',
            operationEntityName: '',
            enityTypeID: '',
            operationEntityLocation: '',
            isActive: true,
            isErpEnabled: false
        })
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true })
    }

    function generateDropDownMenu(data) {

        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<option key={key} value={key}>{value}</option>)
            }
        }
        return items
    }

    return (
            <Fragment>
            <LoadingSpinerComponent/>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <PageHeader
                                title={title}
                                isButtonEnable={true}
                                buttonText="Back to Listing"
                                path="/regularOperationEntity"
                                isChanged={isChanged}
                            />

                            <form onSubmit={(e) => handleSave(e)}>
                            
                                <div className="card-body">

                                    <div className="form-group row">
                                        <div className="col-md pb-1">
                                            <TextField select fullWidth
                                                label="Group *"
                                                id="groupID"
                                                name="groupID"
                                                disabled={!permissionList.isGroupFilterEnabled}
                                                value={company.groupID}
                                                onChange={(e) => handleChange(e)}>
                                                <option value="0">--Select Group--</option>
                                                {generateDropDownMenu(groups)}
                                            </TextField>
                                            {errors["groupID"] && <span id="errbranchCode" className="text text-danger">{errors["groupID"]}</span>}
                                        </div>

                                        <div className="col-md pb-1">
                                            <TextField fullWidth label="Entity Code *"
                                                name="operationEntityCode"
                                                id="operationEntityCode"
                                                value={company.operationEntityCode}
                                                type="number"
                                                maxLength="2"
                                                onChange={(e) => handleChange(e)} />
                                            {errors["operationEntityCode"] && <span id="errbranchCode" className="text text-danger">{errors["operationEntityCode"]}</span>}
                                        </div>

                                        <div className="col-md pb-1">
                                            <TextField fullWidth label="Entity Name *"
                                                name="operationEntityName"
                                                id="operationEntityName"
                                                value={company.operationEntityName}
                                                type="text"
                                                onChange={(e) => handleChange(e)} />
                                            {errors["operationEntityName"] && <span id="errbranchCode" className="text text-danger">{errors["operationEntityName"]}</span>}
                                        </div>
                                    </div>

                                    <div className="form-group row">
                                    <div className="col-md-4">
                                            <TextField select fullWidth
                                                label="Entity Type *"
                                                id="enityTypeID"
                                                name="enityTypeID"
                                                disabled={!permissionList.isGroupFilterEnabled}
                                                value={company.enityTypeID}
                                                onChange={(e) => handleChange(e)}>
                                                <option value="0">--Select Entity type--</option>
                                                {generateDropDownMenu(entityTypes)}
                                            </TextField>
                                            {errors["enityTypeID"] && <span id="errbranchCode" className="text text-danger">{errors["enityTypeID"]}</span>}
                                        </div>

                                        <div className="col-md-4">
                                            <TextField fullWidth label="Location"
                                                name="operationEntityLocation"
                                                id="operationEntityLocation"
                                                value={company.operationEntityLocation}
                                                type="text"
                                                onChange={(e) => handleChange(e)} />
                                            {errors["operationEntityLocation"] && <span id="errbranchCode" className="text text-danger">{errors["operationEntityLocation"]}</span>}
                                        </div>
                                    </div>
                                    
                                 <label>Active</label>
                                    <div className="form-group row">
                                        <div className="col-md ">
                                            <input
                                                id="isActive"
                                                switch="none"
                                                className="mr-2"
                                                type="checkbox"
                                                name="isActive"
                                                onChange={(e) => handleChange(e)}
                                                checked={company.isActive}
                                            />
                                            <label htmlFor="isActive" data-on-label="Yes"
                                                data-off-label="No"></label>
                                        </div>
                                    </div>
                                    <label>Is ERP Enabled</label>
                                    <div className="form-group row">
                                        <div className="col-md pb-1">
                                            <input
                                                className="mr-2"
                                                switch="dark"
                                                id="isErpEnabled"
                                                type="checkbox"
                                                name="isErpEnabled"
                                                onChange={(e) => handleChange(e)}
                                                checked={company.isErpEnabled}
                                            />
                                            <label htmlFor="isErpEnabled" data-on-label="Yes"
                                                data-off-label="No"></label>
                                        </div>
                                    </div>

                                </div>
                                <div className="card-footer">
                                        <input
                                            disabled={validate(schema, company)}
                                            type="submit"
                                            className="btn btn-primary"
                                            value={buttonName}
                                        />
                                        <input
                                            type="button"
                                            className="btn btn-warning pull-right"
                                            value="Clear"
                                            onClick={onCancelClick}
                                        />

                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <MessageModal
                    hidden={messageModel.hidden}
                    messageType={messageModel.type}
                    messageDescription={messageModel.disciption}
                    clicked={modalDismissHandler}
                />
            </Fragment>
    );
}